import { render, staticRenderFns } from "./NationalHolidayList.vue?vue&type=template&id=227f8038&"
import script from "./NationalHolidayList.vue?vue&type=script&lang=ts&"
export * from "./NationalHolidayList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports